import { render } from "./LicenseApplicationEditorCard.vue?vue&type=template&id=f560fcd2"
import script from "./LicenseApplicationEditorCard.vue?vue&type=script&lang=js"
export * from "./LicenseApplicationEditorCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__